import { SubscribeService } from './../../api/subscribe.service';
import { AutorizationService } from './../../api/autorization.service';
import { Component, OnInit } from '@angular/core';
import { UserApiService } from 'src/app/user-api.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  constructor(private autorizationService: AutorizationService, private subscribeService: SubscribeService, private userService: UserApiService)
   { 
    this.getSite()
    this.getFaqs()
   }



  categorie1 = false;
  question1_1 = false;
  question1_2 = false;
  question1_3 = false;
  question1_4 = false;
  question1_5 = false;
  question1_6 = false;
  question1_7 = false;
  question1_8 = false;
  question1_9 = false;
  question1_10 = false;
  question1_11 = false;

  categorie2 = false;
  question2_1 = false;
  question2_1_1 = false;
  question2_2 = false;
  question2_3 = false;
  question2_4 = false;
  question2_5 = false;
  question2_6 = false;
  question2_7 = false;
  question2_8 = false;

  categorie3 = false;
  question3_1 = false;
  question3_2 = false;
  question3_3 = false;
  question3_4 = false;
  question3_5 = false;
  question3_6 = false;
  question3_7 = false;
  question3_8 = false;

  categorie4 = false;
  question4_1 = false;
  question4_2 = false;
  question4_3 = false;
  question4_4 = false;
  question4_5 = false;
  question4_6 = false;
  question4_7 = false;
  question4_8 = false;

  categorie5 = false;
  question5_1 = false;
  question5_2 = false;
  question5_3 = false;
  question5_4 = false;
  question5_5 = false;
  question5_6 = false;
  question5_7 = false;

  categorie6 = false;
  question6_1 = false;
  question6_2 = false;
  question6_3 = false;
  question6_4 = false;
  question6_5 = false;

  categorie7 = false;
  question7_1 = false;
  question7_2 = false;
  question7_3 = false;
  question7_4 = false;
  question7_5 = false;
  question7_6 = false;
  question7_7 = false;
  question7_8 = false;
  question7_9 = false;
  question7_10 = false;

  categorie8 = false;
  question8_1 = false;
  question8_2 = false;
  question8_3 = false;

  categorie9 = false;
  question9_1 = false;
  question9_2 = false;


  body_stat: any;



  new = true


  ngOnInit(): void {
    // this.getIp()
  }



  getIp() {
    this.autorizationService.getIP().subscribe(
      data => {

        console.log(data)
        this.body_stat = data

        this.userService.getCurrentUserData().subscribe(

          res => {

            console.log(res)
            this.body_stat.driver_id = res.id
            this.body_stat.username = res.name
            this.body_stat.community_driver = res.community.name

            this.subscribeService.statFaq(this.body_stat).subscribe(
              data => {

                console.log(data)
              },
              err => {
                console.log(err)
              });
          },
          err => {
            console.log(err)

            this.body_stat.driver_id = 0
            this.body_stat.username = "Not connected"
            this.body_stat.community_driver = "Not connected"

            this.subscribeService.statFaq(this.body_stat).subscribe(
              data => {

                console.log(data)
                this.body_stat = data
              },
              err => {
                console.log(err)
              });
          });
      },
      err => {
        console.log(err)
      });

  }

 faqs: any[] = [];

  getFaqs(){


    this.subscribeService.getFaqs().subscribe(
      res => {

        console.log(res)
        this.faqs = res.data




      },
      err => {
        console.log(err)
      });

    }


    siteType = 'default';

getSite() {
  const host = location.host;

  switch (host) {

    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      this.siteType = 'mam';
      break;

    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
      this.siteType = 'remi';
      break;

    default:
      this.siteType = 'default';
  }
}


}
